import React from 'react';
import NavbarInv from '../../components/navbarInv';
import DatosCapis from '../../components2/datosCapis';

function InfoCapisInv () {
    return (
        <div className='flex flex-col'>
            {/* <NavbarInv /> */}
            <DatosCapis />
        </div>
    )
}

export default InfoCapisInv;